<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.9998 3.8999H5.89941V20.2635H18.6267V10.5001M11.9998 3.8999L18.6267 10.5001M11.9998 3.8999V10.5001H18.6267"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
